import { LitElement, PropertyValues } from 'lit';
import { html, nothing } from 'lit-html';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

@customElement('exercises-chat-bot-shortcut')
export class ExercisesChatBotButton extends LitElement {
    createRenderRoot() {
        return this;
    }

    @state()
    show = false;

    showChatButton() {
        this.show = true;
    }
    

    openChatBot(message: string) {
        this.dispatchEvent(
            new CustomEvent('open', {
                detail: {
                    message,
                },
            })
        );
    }

    render() {
        if (!this.show) return nothing;
        return html`<div class="exercises-chat-bot-shortcut">
            <div class="exercises-chat-bot-shortcut-container">
                <div class="exercises-chat-bot-shortcut-text">
                    <span class="exercises-chat-bot-shortcut-icon icon-085-thumb-tool-ai"></span
                    >Ainda com dúvidas? Nosso Tira Dúvidas pode explicar de outro jeito.
                </div>
                <div class="exercises-chat-bot-shortcut-buttons">
                    <button
                        class="exercises-chat-bot-shortcut-button"
                        @click=${() => this.openChatBot('Explica melhor')}
                    >
                        Explica melhor
                    </button>
                    <button
                        class="exercises-chat-bot-shortcut-button"
                        @click=${() => this.openChatBot('Simplifica')}
                    >
                        Simplifica
                    </button>
                </div>
            </div>
        </div>`;
    }
}
